import { mapApiImageToImageProps } from './common.mappers';

import type { FNewsTemplateProps } from '@/components/templates/FNewsTemplate.vue';

export function mapApiDataToNews(
  newsRawData: StrapiResponseData<BlogPostContentType>[] | undefined,
  guidesRawData: StrapiResponseData<GuideContentType>[] | undefined
): FNewsTemplateProps {
  return {
    blogPostCards: mapApiDataToNewsBlogPosts(newsRawData),
    guideCards: mapApiDataToNewsGuides(guidesRawData),
  };
}

function mapApiDataToNewsBlogPosts(
  newsRawData: StrapiResponseData<BlogPostContentType>[] | undefined
): FNewsTemplateProps['blogPostCards'] {
  return (newsRawData ?? []).map(card => ({
    text: card.attributes?.title || '',
    image: mapApiImageToImageProps(
      card.attributes?.main_image?.data?.attributes,
      'medium'
    ),
    link: {
      location: `/news/${card.attributes?.slug}`,
    },
    linkText: '',
  }));
}

function mapApiDataToNewsGuides(
  guidesRawData: StrapiResponseData<GuideContentType>[] | undefined
): FNewsTemplateProps['guideCards'] {
  return (guidesRawData ?? []).map(card => ({
    title: card.attributes.title ?? '',
    excerpt: card.attributes.excerpt ?? '',
    buttonLocation: `/resources/guides/${card.attributes.slug}`,
    buttonText: '',
  }));
}
